import React, { useState } from "react"
import {IconChevronLeft, IconChevronRight} from "../../../../../components/icons";

type Props = {
  urls: string[]
  onImageError?: (url: string) => void
}

export function PhotoCarousel({ urls, onImageError }: Props) {
  const VISIBLE = 4;
  const [index, setIndex] = useState<number>(0);
  const max = Math.max(urls.length - VISIBLE, 0);

  return (
    <div className="relative w-full overflow-visible">
      {/* Previous */}
      <button
        onClick={() => setIndex(i => Math.max(i - 1, 0))}
        disabled={index === 0}
        className="absolute left-0 top-1/2 -translate-y-1/2 z-10
                   h-12 w-12 rounded-full bg-white shadow
                   flex items-center justify-center
                   transition-opacity duration-200
                   opacity-70 hover:opacity-100 disabled:opacity-0"
      >
        <IconChevronLeft className="w-6 h-6" />
      </button>

      {/* Next */}
      <button
        onClick={() => setIndex(i => Math.min(i + 1, max))}
        disabled={(urls.length - VISIBLE > 0) ? index === urls.length - VISIBLE : true}
        className="absolute right-0 top-1/2 -translate-y-1/2 z-10
                   h-12 w-12 rounded-full bg-white shadow
                   flex items-center justify-center
                   transition-opacity duration-200
                   opacity-70 hover:opacity-100 disabled:opacity-0"
      >
        <IconChevronRight className="w-6 h-6" />
      </button>

      {/* Track */}
      <div className="overflow-hidden">
        <div
          className="flex transition-transform duration-300"
          style={{ transform: `translateX(-${index * 25}%)` }}
        >
          {urls.map((url, key: number) => (
            <div
              key={`${url}-${key}`}
              className="w-1/4 flex-shrink-0 aspect-video
                         bg-gray-100 rounded-lg overflow-hidden px-1"
            >
              <img
                alt={`Véhicule ${key}`}
                src={url}
                className="w-full h-full object-cover rounded-md"
                onError={(e) => {
                  e.currentTarget.onerror = null
                  onImageError?.(url)
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
